const src = require("/app/src/assets/images/svg/hamburger.svg?as-resource");
const img = new String(src);
img.src = src;
img.width = 24;
img.height = 19;
img.toString = function() { return src; };
module.exports = img;